import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../../../../constants/styleConstants';
const useStyles = makeStyles(theme => ({
  divider: {
    margin: `${theme.spacing(2)}px 0`,
  },
  actionBlock: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },
  },
  filterForm: {
    maxWidth: 700,
    flex: 1,
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
      width: '100%',
    },
  },
  addButton: {
    [theme.breakpoints.down('xs')]: {
      marginTop: 10,
    },
  },
  addButtonLink: {
    color: 'inherit',
    '&:visited, &:hover, &:active, &:focus': {
      color: 'inherit',
    },
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  lastUpdate: {
    color: colors.gray,
    fontSize: 11,
  },
  date: {
    fontWeight: 'bold',
    fontSize: 11,
  },
  warning: {
    color: colors.red,
    padding: theme.spacing(1),
    display: 'block',
    textAlign: 'right',
  },
}));

export default useStyles;
